<template>
<div>
  <div v-if="!okay">
    <h1>
      Login to Edit
    </h1>
    <form @submit.prevent="onSend()">
      <div>
        <input type="hidden" :value="spaceID" />
      </div>
      <div class="field">
        <div class="control">
          <input class="input" autocomplete="passgate-of-spaceID" type="password" v-model="session.password">
        </div>
      </div>
      <div class="field">
        <div class="control">
          <input class="button is-primary" type="submit" value="login">
        </div>
      </div>
      <div v-if="err">
        {{ err }}
      </div>
    </form>
  </div>
  <div v-if="okay">
    <div class="field">
      <div class="control">
        <button class="button is-info is-pulled-right" v-if="okay" @click="logout()">Logout</button>
      </div>
    </div>
    <div class="is-clearfix"></div>
    <slot v-if="okay"></slot>
  </div>
</div>
</template>

<script>
import * as API from '../../network/api'
export default {
  props: {
    session: {},
    spaceID: {}
  },
  data () {
    return {
      err: '',
      okay: false
    }
  },
  async mounted () {
    await this.onSend()
    this.err = ''
  },
  methods: {
    logout () {
      this.okay = false
      this.$emit('logout')
    },
    onSend () {
      this.err = ''
      return API
        .checkLogin({
          spaceID: this.spaceID,
          password: this.session.password
        })
        .then(() => {
          this.$emit('password', this.session.password)
          this.okay = true
        }, () => {
          this.err = 'Cant login'
          this.okay = false
        })
    }
  }
}
</script>

<style>

</style>
